import React from 'react'

import closeModal from "../../../../../core/gd/utils/close-modal"
import ControlButtonClose from "../../../../../core/gd-components/buttons/control-button/close"

type Props = {
    className?      : string

    height?         : 60 | 90
    title           : string
    underline?      : boolean
}

export default function ModalV5_Header(props:Props) {

    const height = props.height || 60

    const style = {
        height:     height + 'px'
    }

    //ui5-border-bottom
    const classes = Classes('flex-row-center-space-between position-relative border-box w-100p flex-no-shrink', props.className, {
        'ui5-border-bottom'     : props.underline
    })

    return (
        <div className={classes} style={style}>
            <div className="ui5-title-app-name m-l-25">{props.title}</div>

            <div className="position-absolute t-5 r-5">
                <ControlButtonClose onClick={closeModal}/>
            </div>
        </div>
    )
}